import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CodeTypeName} from 'shared/consts';
import { CodeManagementApiService, SpinningService } from 'shared/services';
@Component({
  selector: 'app-code-selector',
  templateUrl: './code-selector.component.html',
  styleUrls: ['./code-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CodeSelectorComponent),
      multi: true
    }
  ]
})
export class CodeSelectorComponent implements OnInit, ControlValueAccessor {
  @Input() codeType: string;
  @Input() showSearch: boolean;
  @Input() allowClear: boolean;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() showSpinning: boolean;
  @Input() value: string;
  @Input() readOnlyMode: boolean = false;
  @Input() mode: string="default";
  @Input() showEnergySubsections: boolean = true;
  @Output() onCodeChange = new EventEmitter<string>();
  @Output() onLoaded = new EventEmitter<string>();
  @Output() onId = new EventEmitter<string>();
  @Output() onUnitChange = new EventEmitter<string>();

  typeOptions: any[];
  summaryParameters: any[] = [];

  constructor(
    private codeManagementApiService: CodeManagementApiService,
    private spiningService: SpinningService,
    ) { }
  get codeTypeName() {
    return CodeTypeName;
  }
  writeValue(value: string): void {
    this.value = value;
    this.propagateOnChange(value);
    this.emitUnit(value)
  }

  registerOnChange(fn: any): void {
    this.propagateOnChange = fn;
  }

  registerOnTouched(e: any): void {
  }

  
  propagateOnChange (value: any) {
  };

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  async ngOnInit() {

    if (this.showSpinning) {
      const action$ = this.spiningService.startWith(this.codeManagementApiService.getCodeList(this.codeType))
      action$.subscribe((res: any) => {
        this.typeOptions = res;
        this.onLoaded.emit(res);
        this.emitUnit(res[0]?.key ?? '')
      })
    } else {
      this.codeManagementApiService.getCodeList(this.codeType).subscribe((res: any) => {
        this.typeOptions = res;
        this.onLoaded.emit(res);
        this.emitUnit(res[0]?.key ?? '')
      });
    }
  };

  codeChange($event: string) {
    this.onCodeChange.emit($event);
    this.propagateOnChange($event);
    this.emitUnit($event)
  }

  emitUnit(type) {
  }
}
